import { render, staticRenderFns } from "./ForumChatThreadCard.vue?vue&type=template&id=2cb9d06c&scoped=true"
import script from "./ForumChatThreadCard.vue?vue&type=script&lang=js"
export * from "./ForumChatThreadCard.vue?vue&type=script&lang=js"
import style0 from "./ForumChatThreadCard.vue?vue&type=style&index=0&id=2cb9d06c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb9d06c",
  null
  
)

export default component.exports